
import React from 'react';
import '../css/skipToMain.css'


interface SkipToMainProps {
    mainId?: string;
  }

const SkipToMain: React.FC<SkipToMainProps> = ({ mainId = 'main-content'}) => {


  return (
    <>
    <a href={`#${mainId}`} className="skip-to-main">
      Skip to main content
    </a>
    </>
  );
};

export default SkipToMain;


